import { useMantineTheme } from "@mantine/core";

type FontWeights = {
  medium: number;
  semiBold: number;
  normal: number;
};

type Strength = 1 | 2;

function getWeight(fontWeights: FontWeights, strength: number) {
  switch (strength) {
    case 1:
      return fontWeights.medium;
    case 2:
      return fontWeights.semiBold;
    default:
      return fontWeights.normal;
  }
}

export function Strong({
  children,
  strength = 1,
}: {
  children: React.ReactNode;
  strength?: Strength;
}) {
  const theme = useMantineTheme();
  const fontWeight = getWeight(theme.other.fontWeights, strength);
  return <strong style={{ fontWeight }}>{children}</strong>;
}
